import BusinessMembersTable from '@/components/businesses/BusinessMembersTable';
import { useGetBusinessDetails } from '@/hooks/requests/useBusinesses';
import { Card, Typography } from '@mui/material';

type BankApplicationBusinessMembersProps = {
  businessId?: string;
};

export default function BankApplicationBusinessMembers({
  businessId = '',
}: BankApplicationBusinessMembersProps) {
  const { businessDetails } = useGetBusinessDetails(businessId);

  if (!businessDetails) {
    return null;
  }

  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Business Members
      </Typography>
      <BusinessMembersTable members={businessDetails?.members} />
    </Card>
  );
}
